interface IClientProps {
  id?: string | null;
  name?: string | null;
  url?: string | null;
}

export const buildClientUrl = (relativeUrl: string, client?: IClientProps): string => {
  if (client?.url) return `/client/${client.id}${relativeUrl}`;

  return relativeUrl;
};

export const buildClientEntity = (entity: string, client?: IClientProps): string => {
  if (client?.id) return `${entity}-${client.id}`;
  return entity;
};
